<template>
  <div class="root">
   <span
       v-tooltip.top="{
              content: client.scheduled_calls.length > 0?
              (formatDate(client.scheduled_calls[0].scheduled_on).includes('-')?
              (formatDate(client.scheduled_calls[0].scheduled_on,true) + ' Left to call this client').replace('-','')
              :formatDate(client.scheduled_calls[0].scheduled_on,true) + ' Passed from call to this client'
              ):''
            }"
       class="time-text"
       :class="{
     online:formatOnlineDate(client.last_online) !== '0 m' && !!formatOnlineDate(client.last_online),
     missed:client.scheduled_calls.length > 0 &&
       !formatDate(client.scheduled_calls[0].scheduled_on).includes('-')
       }"
       v-if="
       client.scheduled_calls.length > 0 &&
       formatDate(client.scheduled_calls[0].scheduled_on) !== ''"
   >
      {{ formatDate(client.scheduled_calls[0].scheduled_on) }}
   </span>
  </div>
</template>

<script>
import moment from "moment";

export default {
name: "ClientScheduledCallsDiff.component",
  data(){
  return{
    dateNow:null,
  }
  },
  mounted() {
  this.dateNow = moment();
    this.time()
  },
  watch:{
    key:function(){
    this.key -= 1
  },
  },
  props:{
  client:{
    required:true,
    type:Object
  },
    update:{
    required:true,
    type:Boolean
  },
    key:{
    required:false,
    type:Number
  }
  },
  methods:{
    time() {
      let self = this
      this.dateNow = moment()

      let update = setTimeout(self.time, 1000)
    },
    formatDate(date,full = false) {
      let text = "";

      let now = this.dateNow;
      let end= moment(String(date));
      let diffS = end.diff(now, "seconds");
      let diffM = end.diff(now, "minutes");
      let diffMR = end.diff(now, "minutes");
      let diffH = end.diff(now, "hours");
      let diffD = end.diff(now, "days");
      let diffMO = end.diff(now, "months");
      let diffY = end.diff(now, "years");

      if(diffM > 0 ){
        diffM = diffM+1;

      }
      if(diffS > 0){
        text = text + '-'
      }
      diffS = Math.abs(diffS);
      diffM = Math.abs(diffM);
      diffH = Math.abs(diffH);
      diffD = Math.abs(diffD);
      diffMO = Math.abs(diffMO);
      diffY = Math.abs(diffY);
      diffMR = Math.abs(diffMR);

      if (diffM >= 60) {
        diffM = diffM % 60;
      }
      if (diffH > 24) {
        diffH = diffH % 24;
      }

      if (diffD >= 30) {
        diffD = diffD % 30;
      }
      if (diffMO >= 12) {
        diffMO = diffMO % 12;
      }


      if (diffY > 0) {
        text += diffY + "Y";
      }

      if (diffMO < 12 && diffMO > 0) {
        text += diffMO + "MO";
      }
      if (diffD < 30 && diffD > 0) {
        text += diffD + "D";
      }
      if (diffH < 24 && diffH > 0) {
        text += diffH + "H";
      }
      if (diffM < 60 && diffM > 0) {
        text += diffM + "m";
      }

      if(diffS > 0 && diffS < 60){
        text += diffS + "s";
      }
      if(full){
        text = text.replace('s',' Seconds')
        text = text.replace('m',' Minutes')
      }
      if(diffMR >= 60){
        text = "";
      }


      return text;

    },
    formatOnlineDate(date) {
      const now = moment().subtract(2, "hours");
      const end = moment(String(date));
      const diff = now.diff(end, "minutes");
      if (diff < 60 && diff >= 0) {
        return diff + " m";
      }
      if (diff > 60) {
        return false;
      }
    }
  },
}
</script>

<style scoped>
.root {
  float: right;
  cursor: pointer;
  position: relative;
  font-size: 10px;
}
.time-text {
  font-size: 9px;
  position: absolute;
  width: max-content;
  right: 4px;
  top: 4px;
  color: #d79300;
  font-weight: 600;
}
.time-text.online {
  font-size: 9px;
  position: absolute;
  width: max-content;
  right: 4px;
  top: 15px
}
.missed{
  color: #990000;
}

</style>